export enum NotificationSeverity {
    Information = 0,
    Important = 1,
    Danger = 2
}

export interface INotification {
    notificationId: string;
    raceId: string;
    riderId?: string | null;
    subject?: string | null;
    description?: string | null;
    severity: NotificationSeverity;
    notificationStart: Date;
    notificationEnd?: Date | null;
    isActive: boolean;
}

export interface ICreateNotification {
    description: string;
    severity: NotificationSeverity;
    notificationStart: Date;
    notificationEnd?: Date | null;
}
